import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { DesignSystem } from './pages/DesignSystem';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3ka4bd2zaadjv">
      <Routes data-id="element-1" data-mp="3k8jiriwj54on">
        <Route path="/" element={<Landing data-id="element-3" data-mp="3k7i3114kju0l" />} data-id="element-2" data-mp="3k92p02cti4mu" />
        <Route path="/design-system" element={<DesignSystem data-id="element-5" data-mp="3fbt32won0b3r" />} data-id="element-4" data-mp="3farfjsqfpw55" />
      </Routes>
    </BrowserRouter>;
}